import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class GoodInventoryValuation  {
    _originalTypeClassName = "zERP.BO.GoodInventoryValuation";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
GoodInventoryValuation.translate = translateService;
}
this.Methods = [];
this.Id = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Good:any;
Methods:any;
static setGood = ($this, value) => {
var oldValue = $this.Good;
$this.Good = value;
if (value != null) {
}
}
static setMethods = ($this, items) => {
                if (items == null) items = [];
                if ($this.Methods == null) $this.Methods = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Methods.length > 0) {
                    Domain.GoodInventoryValuation.removeMethods($this, $this.Methods[0]);
                }

                Domain.GoodInventoryValuation.addManyMethods($this, copyItems);
            }
static addManyMethods = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.GoodInventoryValuation.addMethods($this, items[i]);
                }
            }
static addMethods = ($this, item) => {
                if ($this.Methods == null) $this.Methods = [];
                if (item == null || $this.Methods.indexOf(item) > -1) return;
                $this.Methods.push(item);
}
static addRangeMethods = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.GoodInventoryValuation.addMethods($this, item));
            }
static removeMethods = ($this, item) => {
                if ($this == null || $this.Methods == null || $this.Methods.indexOf(item) === -1) return;
                var _index = $this.Methods.indexOf(item);
                $this.Methods.splice(_index, 1);
}
static clearMethods = ($this) => { $this.Methods = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}